module.exports = __webpack_public_path__ + "img/jsfni2.a7d58edd.png";